import { Box, Skeleton } from '@mui/material';
import React from 'react';
import ColumnLayout from '../../layouts/column';

function EventDetailsSkeleton() {
  return (
    <Box justifyContent="center" display="flex">
      <Box mx="16px" width="50vw" minWidth="350px" maxWidth="550px">
        <ColumnLayout alignItems="flex-start" overflow="flex">
          <Skeleton variant="text" sx={{ fontSize: '64px' }} width="60%" />
          <Skeleton variant="text" sx={{ fontSize: '48px' }} width="50%" />
          <Skeleton variant="text" sx={{ fontSize: '48px' }} width="70%" />
          <Skeleton variant="rounded" width="100%" height="200px" />
          <Skeleton variant="text" sx={{ fontSize: '48px' }} width="60%" />
          <Skeleton variant="rounded" width="100%" height="300px" />
        </ColumnLayout>
      </Box>
    </Box>
  );
}

export default EventDetailsSkeleton;
